import { BehaviorParameters } from 'rangeConfig/@types';
import { setAutoFillSheetVisible } from '../AutofillPax';

const openAutofillSheet = ({ dispatch }: BehaviorParameters) => {
  // Reset the group selection to show mobile menu default state when autofill is closed
  dispatch(setAutoFillSheetVisible(true));
};

export default openAutofillSheet;
